export default __webpack_public_path__ + "static/store-badge-apple.a2bd52bf.svg";